import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IClinicIncentivePeriodModel extends IModel {
  clinicIncentivePeriodId: number;
  name: string;
  startDate: string;
  endDate: string | undefined;
}

export class ClinicIncentivePeriodModel
  extends Model
  implements ModelRecord<IClinicIncentivePeriodModel>
{
  clinicIncentivePeriodId: number;
  name: string;
  startDate: string;
  endDate: string | undefined;

  constructor(params?: Partial<IClinicIncentivePeriodModel>) {
    super(params);
    this.clinicIncentivePeriodId = defaultTo(
      params?.clinicIncentivePeriodId,
      0,
    );
    this.name = defaultTo(params?.name, '');
    this.startDate = defaultTo(params?.startDate, '');
    this.endDate = defaultTo(params?.endDate, undefined);
  }
}
